var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("AddToCartPopinCds", {
    ref: "addToCartPopinCds",
    attrs: {
      id: _vm.modalId,
      title: _vm.content.title,
      "offer-name": _vm.offerName,
      advantages: [..._vm.content.advantages],
      "selected-offer-info": _vm.selectedOfferInfo,
      visual: _vm.visual,
      "with-device-section": _vm.withDeviceSection,
      "without-device-section": _vm.withoutDeviceSection,
      "is-sub": false,
      "cart-page-url": _vm.secondIntentionHref,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }